/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import City from './City/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Edit/Content/Fields"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
{children}
</React.Fragment>)
}